import(/* webpackMode: "eager" */ "/workspace/frameworkassure/src/app/(auth)/login/error.tsx");
